import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from '@firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyDZ5QWSLyX5KZz78e4wzDpRajhJrieQMzw',
  authDomain: 'merits-account.firebaseapp.com',
  projectId: 'merits-account',
  storageBucket: 'merits-account.appspot.com',
  messagingSenderId: '972149652485',
  appId: '1:972149652485:web:c6cbf9844139a9d4f9b06c',
  measurementId: 'G-FJE40XMRSQ',
};

// const firebaseConfig = {
//   apiKey: 'AIzaSyBY84aJng-tmMahDNXS4d9Yp104PkqiKxM',
//   authDomain: 'pedro-test-82f7c.firebaseapp.com',
//   databaseURL: 'https://pedro-test-82f7c-default-rtdb.firebaseio.com',
//   projectId: 'pedro-test-82f7c',
//   storageBucket: 'pedro-test-82f7c.appspot.com',
//   messagingSenderId: '339199099101',
//   appId: '1:339199099101:web:6e8089e76e4f1ccc5a1b34',
// };

const app = initializeApp(firebaseConfig);

export const auth = getAuth();
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
